import DefaultElementNodeType from '../DefaultElementNodeType';
import {IMP_MIG_PLATEAU} from '../../metamodel/Concept';

export default class PlateauNodeType extends DefaultElementNodeType {
	static get typeName() {
		return IMP_MIG_PLATEAU;
	}
}
